import React, { useState, useEffect} from "react";
import { LoyaltyTwoTone } from "@material-ui/icons";
import axios from "axios";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import SalesOrderInfoTable from "./SalesOrderInfoTable";
import SalesAddItem from "./SalesAddItem";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import {  useParams, useHistory } from "react-router-dom";
import { format } from "date-fns";


//number format plugin
import numeral from "numeral";

import PurchaseOrderInfoTable from "../../Purchases/PurchaseOrderInfoTable";
import PurchaseAddItem from "../../Purchases/PurchaseAddItem";
import PurchaseEditShipping from "../../Purchases/PurchaseEditShipping";
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { NavLink } from "react-router-dom";
import Preloader from "../../../components/Preloader/Preloader";

import Slide from '@material-ui/core/Slide';
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
});

const AccountUpgradePay = () => {
	const istype = 'notbranch'; // hardcode for now
        const location = useLocation();
        const { warehouse, topay, reference_no ,total_php,totalCount} = location.state || {};
	const { shippingId, warehouseId, idNo, trantype } = useParams();
	const [soDetails, setSoDetails] = useState(null);

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	const [items, setItems] = useState([]); //data to display in SO table
	const [supplierItem, setSupplierItem] = useState([]); 
	const [showModal, setShowModal] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(true); // for saving of items, shipping and notes
	const [btnDisabled2, setBtnDisabled2] = useState(true); //for saving of sales order
	const [advancepayment, setAdvancepayment] = useState("no");

    //Message Box
    const [showMsgBox, setShowMsgBox] = useState(false);
    const [msgBoxContent, setMsg] = useState("Empty");
    const [msgType, setMsgType] = useState("success");
    const [message, setMessage] = useState("");
    //Message Box EOF

	//salesOrderPayment
	const [showPaymentPage, setShowPaymentPage] = useState(true);
	//Payment Type dropdown data
	const [paymentType, setPaymentType] = useState([]);
	const [paymentId, setPaymentId] = useState(0);
	const [paymentAmount, setPaymentAmount] = useState(0);
	const [paymentReference, setPaymentReference] = useState('');
	const [grandTotal, setGrandTotal] = useState(0);
	const [maxQty,setMaxQty] =useState(0);
	
	// combine all payment details neeeded before saving final SO
	// {
    //     "payment_id":paymentId,
    //     "payment_amount": parseFloat(paymentAmount),
    //     "payment_ref":paymentReference
    // }
	let history = useHistory();
	const classes = useStyles();
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => { //
		proceed_so();
	}, []);

	
	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.item_id);
		if(found){
			// console.log('hehe',item);
			// //if item is existing in itemArray, add the qty instead
			// let newItems = items.map((it)=> {
			// 	if(it.item_id === item.item_id){ //add
			// 		it.qty += item.qty;
			//   	}
			//   return it;
			// });
			// setItems(newItems);
			let newItems = items.map((it) => {
				if (it.item_id === item.item_id) {
				  const newQty = it.qty + item.qty;
				  if (item.maxQty !== undefined && newQty > item.maxQty) {
					setShowMsgBox(true);
					setMsg("Quantity exceeds available stock.");
					setMsgType("error");
					setTimeout(() => {
					  setShowMsgBox(false);
					}, 2500);
				    return it; // don't update qty
				  }
				  it.qty = newQty;
				}
				return it;
			      });
			      setItems(newItems);
			
		}else{
			// console.log('2',item);
			//add new unique item to array
			if (item.maxQty !== undefined && item.qty > item.maxQty) {
				setShowMsgBox(true);
				setMsg("Quantity exceeds available stock.");
				setMsgType("error");
				setTimeout(() => {
				  setShowMsgBox(false);
				}, 2500);
				return;
			      }
			setItems([...items, 
				{
				item_id: item.item_id, 
				qty: item.qty,
				price: item.price, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		//console.log(item_id);
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty))
		setPoTotal(po_total);

		if(items.length > 0 && advancepayment) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items,advancepayment]);

	useEffect(() => {
		if(    paymentId &&
			Number(paymentAmount) === topay &&
			paymentReference &&
			paymentReference.trim() !== '') {
			setBtnDisabled2(false); // re-enable
		}else{
			setBtnDisabled2(true); // re-enable	
		}
	
	}, [paymentId,paymentAmount,topay,paymentReference]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/sales_order_form', {
			params:{
				jc_u_idno: get_cookies('branchidno'),  //branchIdNo
				trandate: format(new Date(), "yyyy-MM-dd"), 
				shipping: shippingId, 
				warehouse: warehouseId, 
				idno: idNo, 
				trantype: trantype, 
				curcode: get_cookies('curcode'), 
			}
		}).then((res)=>{
			setSoDetails(res.data.data);
			setSupplierItem(res.data.data.items);
		}).catch((error)=>{
			//console.log(JSON.stringify(error));
			setShowMsgBox(true);
			// setMsg("Something went wrong: "+error.message);
			setMsg("ID No not found");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		});


	}
	const selectType = [
		{ title: "No Advance Payment", value:'no' },
		{ title: "With Advance Payment/Sales Return", value:'yes'  }
	]
	const defaultProps = {
		options: selectType,
		getOptionLabel: (option) => option.title,
	};
	const checkPaymentProps = {
		options: paymentType,
		getOptionLabel: (option) => option.description,
	};
	
	// totalamount:
	// notes:
	// advancepayment:
	// pricecat:
	// idno:
	// shippingcharge:
	// trantype:
	// curcode:
	// istype:
	// item_array:

	const proceed_so = async () => {
		//setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("branchidno",  get_cookies('branchidno'));
	
			//show 3rd ui, sales order payment
			await axios.post(process.env.REACT_APP_API_URL+'get_payment_list', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
			}).then((res)=>{
				// setSoDetails(res.data.data);
				// setSupplierItem(res.data.data.items);
				setPaymentType(res.data.data.payment_options);
				setShowPaymentPage(true); // show salesORderPayment form, hides current layouts
				// console.log(res.data.data.payment_options);
			}).catch((error)=>{
				// console.log(error.message);
			});
	
	}

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	const save_final_so = () => {
		setBtnDisabled2(true); // disable button to avoid multiple saves
		setShowModal(true);
		const formData = new FormData();
	
		formData.append("paymentId", paymentId);
		formData.append("username", get_cookies('username'));
		formData.append("paymentAmount", total_php);
		formData.append("paymentReference", paymentReference);
		formData.append("reference_no", reference_no);
		formData.append("hqidno", get_cookies('branchidno'));
		
		//formData.append("jc_sopreorder", ""); //not pre-orders;
			//show 3rd ui, sales order payment
		axios
				      .get(process.env.REACT_APP_API_URL + "fetch_reference", {
					params: {
					  reference_no: reference_no,
					  jc_u_idno: get_cookies("branchidno"),
					  curcode: get_cookies("curcode"),
					},
				      })
				      .then((res) => {
						// console.log('res',res.data);
					if(res.data.data == null){
						setShowModal(false);
						setShowMsgBox(true);
						setMsg("No results found for your search.");
						setMsgType("warning");
						setTimeout(() => {
						  setShowMsgBox(false);
						  history.push(`/WholesaleMenu`);
						}, 2500);
					}else if(res.data.data.date_paid !== "0000-00-00"){
						setShowModal(false);
						setShowMsgBox(true);
						setMsg("Account Upgrade has been already paid");
						setMsgType("warning");
						setTimeout(() => {
						  setShowMsgBox(false);
						  history.push(`/WholesaleMenu`);
						}, 2500);
					}else{
						// console.log('totalCount',totalCount);
						const newDelay = totalCount * 5000;
							// console.log('newDelay',newDelay);
						setTimeout(() => {
						  setShowMsgBox(false);
						  history.push(`/WholesaleMenu`);
						}, newDelay);
						
							// setShowModal(false);
							// setShowMsgBox(true);
							// setMsg("We’re processing your payment in the background. You don’t need to wait — it will complete automatically.");
							// setMsgType("success");
							// setTimeout(() => {
							// 	setShowMsgBox(false);
							// 	history.push('/WholesaleMenu');
							// }, 5000)
					 axios.post(process.env.REACT_APP_API_URL+'save_upgrade_payment', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
						}).then(function (res) {   
	
						if(res.data.result.successful == 1){
							// setMsg("Payment was successful.");
							// setMsgType("success");
							// setTimeout(() => {
							// 	setMessage('Payment was successful.')
							// 	setShowModal(false);
							// 	history.push('/WholesaleMenu');
							// }, 5000)
						}else{

							setShowMsgBox(true);
							setMsg(res.data.result.info);
							setMsgType("warning");
							setTimeout(() => {
								setShowModal(false);
								setShowMsgBox(false);
								setBtnDisabled2(false); // re-enable
								history.push(`/WholesaleMenu`);
							}, 2500)
						}

						}).catch(function (error) {
							setShowModal(false); //hide loading/please wait modal 
							setShowMsgBox(true);
							setMsg("We couldn’t process the payment right now. Try again later.");
							setMsgType("warning");
							setTimeout(() => {
								setShowMsgBox(false);
								setBtnDisabled2(false);
								history.push(`/WholesaleMenu`); // re-enable
							}, 5000)
						});
						
					}
				
				
				      })
				      .catch((error) => {
					// console.log(error.message);
				      });
	}

	return (
		<div className="page">
				<LoadingModal message={"Please wait while we process your payment. Do not refresh or close this browser."} showModal={showModal}/>
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/WholesaleMenu"}><h4 style={{color:"#339933"}}>Wholesale</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/sales/account-upgrade-pay"}><h4 style={{color:"#339933"}}>Account Upgrade Payment</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4 className="header-title">Account Upgrade Payment Information</h4>
			</div>
			{!showPaymentPage ? (
			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				{supplierItem && soDetails ? (				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Sales Order Information
								</div>
								<div className={classes.title}>
									{soDetails.name || ''}
								</div>
							</Grid>
							{/* <Grid
								item
								xs={4}
								className={classes.buttonContainer}> */}
								<Grid item xs={12} lg={4}>
									{/* <Autocomplete
											{...defaultProps}
											id="auto-complete"
											autoComplete
											includeInputInList
											className={classes.autoComplete}
											style={{marginTop:"2px", marginBottom:"1em"}}
											renderInput={(params) => (
												<TextField
													{...params}
													label="Advance Payment..."
													margin="normal"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													console.log(newValue.title);
													setAdvancepayment(newValue.value);
												}else{
													setAdvancepayment(null);
												}
											}}
									/> */}
								</Grid>
								<Grid item xs={12} lg={8}>
									<Grid container spacing={3} style={{justifyContent: "flex-end"}}>
										{soDetails.shipping == "Pick Up"?null:	<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>}
										
											<SalesAddItem addItem={addItem} supplierItem={supplierItem} setMaxQty={setMaxQty}/>
											{/* <div style={{marginRight: "1em"}}></div> */}
										{/* <div style={{marginRight: "0.5em"}}></div> */}
									</Grid>
								</Grid>	
							</Grid>

					</div>
					<CardContent>
					
						<Grid container spacing={1}>
							<Grid item xs={12} lg={6} xl={6}>
								<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										ID No:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.idno || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Date:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.date || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Shipping:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.shipping || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Contact No:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.contact_no || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Transaction Type:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.trantype || ''}
									</Grid>
								</Grid>
								</div>	
							</Grid>
							<Grid item xs={12} lg={6} xl={6}>
								<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										JC Wallet:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.jcwallet || ''}
									</Grid>
								</Grid>
								</div>
							</Grid>
						</Grid>
						{/* <SalesOrderInfoTable /> */}
						<SalesOrderInfoTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "+ numeral(shipTotal).format('0,0.00')}		
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(Number(shipTotal)+Number(poTotal)).format('0,0.00')}
								</div>
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>) : (<Preloader />)}
				<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button> */}
					<ColorButton disabled={btnDisabled} onClick={proceed_so} variant="contained" color="primary" classes={{
   		root: classes.root, 
        disabled: classes.disabled}}>
						Proceed
					</ColorButton>
				</div>
		</div>) : (<></>)}


{/* Sales Order Payment Page */}
			{showPaymentPage ? 
				(<Slide direction="up" in={showPaymentPage} mountOnEnter unmountOnExit>
				<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							{/* <Grid item xs={8}>
								<div className={classes.subTitle}>
								Sales Order
								</div>
								<div className={classes.title}>
								Sales Order
								</div>
							</Grid> */}
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs="12" lg="4" xl="3" style={{marginTop:"1.7em"}}>
									<form noValidate autoComplete="off">
										<TextField
													id="outlined-required"
													label="Amount To Pay"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={numeral(topay).format('0,0.00')} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>	
										<Autocomplete
													{...checkPaymentProps}
													id="auto-complete"
													autoComplete
													includeInputInList
													className={classes.autoComplete}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Payment Type"
															margin="normal"
															variant="outlined"
														/>
													)}
													onChange={(event, newValue) => {
														if (!newValue == "" || !newValue == null){
															// console.log(newValue);
															setPaymentId(newValue.id);
														}else{
															setPaymentId(null);
														}
													}}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Amount"
													variant="outlined"
													type="number"
													fullWidth={true}
													className={classes.field}
													value={paymentAmount} //to avoid label overlapping bug
													InputProps={{ inputProps: { min: 0 } }}
													onKeyPress={(e) => { 
														if(e.key == '-'){
															e.preventDefault();
														}
													 }}
													onChange={e => {
														setPaymentAmount(e.target.value);
													}}
													onBlur={(e) => {
														if(parseFloat(e.target.value) > 0){
															setPaymentAmount(e.target.value);
														}else{
															setPaymentAmount(0);
														}
													}}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Reference"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={paymentReference} //to avoid label overlapping bug
													onChange={(e)=>{setPaymentReference(e.target.value)}}
										/>
											</form>
							</Grid>
					        </Grid>
						</Grid>
					</div>	
				</Card>				
					<div className={classes.buttonContainer}>
					{/* fire different api depending if branch or not */}
					{/* {istype='branch'?(<div>Save Sales Order Branch (save_final_so_branch)</div>):(<div>Save Sales Order (save_final_so)</div>)} */}
					<ColorButton disabled={btnDisabled2} variant="contained" color="primary" onClick={()=>{save_final_so()}} classes={{
    					root: classes.root, 
        				disabled: classes.disabled}}>
						Process Payment
					</ColorButton>
					</div>
				</div>		
			  	</Slide>) : (<></>)}

		</div>

	);
};

export default AccountUpgradePay;
